import AgentHubEarnYourOwnTourModal from 'agentHub/components/AgentHubEarnYourOwnTourModal'
import { isAgentHubEarnYourOwnTourModalDismissed } from 'agentHub/storage/agentHubEarnYourOwnTourModalStorage'
import { isAgentHubEnabled } from 'agentHub/selectors/agentHubSelectors'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { useContext, useEffect, useRef, useState } from 'react'
import { selectLoggedIn } from 'selectors/accountSelectors'

function useAgentHubEarnYourOwnTourLoginModal() {
  const showModal = useContext(ModalContext)
  const loggedIn = useAppSelector(selectLoggedIn)
  const hasShown = useRef(false)
  const [canShowAfterLogin, setCanShowAfterLogin] = useState(false)

  useEffect(() => {
    if (!loggedIn) {
      setCanShowAfterLogin(true)
    }
  }, [loggedIn])

  useEffect(() => {
    if (!isAgentHubEnabled) return
    if (!loggedIn) return
    if (!canShowAfterLogin) return
    if (hasShown.current) return
    if (isAgentHubEarnYourOwnTourModalDismissed()) return

    hasShown.current = true
    showModal(<AgentHubEarnYourOwnTourModal />)
  }, [showModal, loggedIn, canShowAfterLogin])
}

export default useAgentHubEarnYourOwnTourLoginModal
